import { apiCall } from './api';
import { CONFIRMATION_PAGE, CONFIRMATION_PAGE_DETAILS, CONFIRMATION_PAGE_STATUS, CONFIRMATION_PAGE_STATS, PUBLIC_CONFIRMATION_PAGE } from '../config/api';

// Get all Confirmation Page items
export const getConfirmationPage = async (params = {}) => {
  try {
    console.log('🚀 getConfirmationPage called with params:', params);
    console.log('🔗 Making API call to:', CONFIRMATION_PAGE);
    
    const response = await apiCall(CONFIRMATION_PAGE, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getConfirmationPage:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getConfirmationPage:', error);
    throw error;
  }
};

// Get Confirmation Page item by ID
export const getConfirmationPageById = async (contentId) => {
  try {
    const endpoint = CONFIRMATION_PAGE_DETAILS.replace('{id}', contentId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Confirmation Page item:', error);
    throw error;
  }
};

// Create new Confirmation Page item
export const createConfirmationPage = async (contentData) => {
  try {
    console.log('🚀 createConfirmationPage called with data:', contentData);
    console.log('🔗 Making API call to:', CONFIRMATION_PAGE);
    
    const response = await apiCall(CONFIRMATION_PAGE, {
      method: 'POST',
      data: contentData
    });
    
    console.log('📡 API Response from createConfirmationPage:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating Confirmation Page item:', error);
    throw error;
  }
};

// Update Confirmation Page item
export const updateConfirmationPage = async (contentId, contentData) => {
  try {
    const endpoint = CONFIRMATION_PAGE_DETAILS.replace('{id}', contentId);
    console.log('🚀 updateConfirmationPage called with ID:', contentId, 'and data:', contentData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: contentData
    });
    
    console.log('📡 API Response from updateConfirmationPage:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating Confirmation Page item:', error);
    throw error;
  }
};

// Delete Confirmation Page item
export const deleteConfirmationPage = async (contentId) => {
  try {
    const endpoint = CONFIRMATION_PAGE_DETAILS.replace('{id}', contentId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting Confirmation Page item:', error);
    throw error;
  }
};

// Update Confirmation Page status
export const updateConfirmationPageStatus = async (contentId, status) => {
  try {
    const endpoint = CONFIRMATION_PAGE_STATUS.replace('{id}', contentId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating Confirmation Page status:', error);
    throw error;
  }
};

// Get Confirmation Page statistics
export const getConfirmationPageStats = async () => {
  try {
    const response = await apiCall(CONFIRMATION_PAGE_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Confirmation Page stats:', error);
    throw error;
  }
};

// Get Public Confirmation Page by site ID
export const getPublicConfirmationPage = async (siteId) => {
  try {
    const endpoint = PUBLIC_CONFIRMATION_PAGE.replace('{site_id}', siteId);
    console.log('🚀 getPublicConfirmationPage called with site_id:', siteId);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    
    console.log('📡 API Response from getPublicConfirmationPage:', response);
    return response;
  } catch (error) {
    console.error('Error fetching Public Confirmation Page:', error);
    throw error;
  }
};

